import { useEffect, useCallback } from "react";
import styles from "../../pages/BulkSchema/styles.module.sass";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Form } from "react-bootstrap";
import { addSchema, deleteSchema } from "../../state/actions/agentActions";
import { fetchPropertyByRealId } from "../../state/actions/propertyActions";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ALLOWED_ROLES } from "../../constants/filters";
import SchemaImage from "./SchemaImage";
import SchemaUploadForm from "./SchemaUploadForm";

const SingleSchema = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const property = useSelector((state) => state.property.currentProperty);
  const userRole = useSelector((state) => state.account.user?.role);
  const isAgent = ALLOWED_ROLES.includes(userRole);

  useEffect(() => {
    dispatch(fetchPropertyByRealId(id));
  }, [dispatch, id]);

  const handleDelete = useCallback(() => {
    dispatch(deleteSchema(property.id, id));
  }, [dispatch, property.id, id]);

  const handleAddSchema = useCallback(
    (values) => {
      dispatch(addSchema(property.id, values.pictures, id));
    },
    [dispatch, property.id, id]
  );

  return (
    <div className={styles.container}>
      <h5>
        {isAgent
          ? `Skica za nekretninu sa šifrom #${property.property_code}`
          : "Skice dodati u jpg formatu"}
      </h5>
      <Row>
        <Col>
          <Formik onSubmit={handleAddSchema} initialValues={{}}>
            {({ handleSubmit, setFieldValue, values, touched, errors }) => (
              <Form>
                {!isAgent && (
                  <SchemaUploadForm
                    onFileChange={(e) =>
                      setFieldValue("pictures", e.currentTarget.files)
                    }
                    onSubmit={handleSubmit}
                    values={values}
                    touched={touched}
                    errors={errors}
                  />
                )}
                <Row
                  style={{ width: 400, marginLeft: 20 }}
                  className="d-flex align-items-center justify-content-center flex-column"
                >
                  <Col
                    style={{
                      position: "relative",
                      width: "400px!important",
                      height: 400,
                      marginTop: 50,
                    }}
                  >
                    <SchemaImage
                      scheme={property.scheme}
                      date={property.date}
                      isAgent={isAgent}
                      onDelete={handleDelete}
                    />
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Col>
      </Row>
    </div>
  );
};

export default SingleSchema;
